/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_Outcome_EmptyInputs */

const cs_lustrace_outcome_empty = /** @type {(inputs: Lustrace_Outcome_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prázdné`)
};

const en_lustrace_outcome_empty = /** @type {(inputs: Lustrace_Outcome_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty`)
};

/**
* | output |
* | --- |
* | "Empty" |
*
* @param {Lustrace_Outcome_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_outcome_empty = /** @type {((inputs?: Lustrace_Outcome_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_Outcome_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_outcome_empty(inputs)
	return cs_lustrace_outcome_empty(inputs)
});